import { useSyncExternalStore } from 'react';

let collapsed = false;
const listeners = new Set<() => void>();

export function isSidebarCollapsed(): boolean {
  return collapsed;
}

export function setSidebarCollapsed(value: boolean | ((prev: boolean) => boolean)): void {
  const next = typeof value === 'function' ? value(collapsed) : value;
  if (next !== collapsed) {
    collapsed = next;
    listeners.forEach((l) => l());
  }
}

export function toggleSidebar(): void {
  setSidebarCollapsed(!collapsed);
}

export function useSidebarCollapsed(): [boolean, (value?: boolean) => void] {
  const isCollapsed = useSyncExternalStore(
    (onStoreChange) => {
      listeners.add(onStoreChange);
      return () => listeners.delete(onStoreChange);
    },
    isSidebarCollapsed,
    () => false,
  );
  return [isCollapsed, (val?: boolean) => (val !== undefined ? setSidebarCollapsed(val) : toggleSidebar())];
}
